import {memo} from 'react';
import Link from 'next/link';
import Image from 'next/image';

const LandscapeBanner = props => {
	const {styles, item} = props;
	return (
		<div
			className={`${styles.landScapeBanner} col-12 col-md-12 col-lg-12 col-xl-12`}
		>
			{item.href ? (
				<Link href={item.href} passHref>
					<a target='_blank'>
						<div className={styles.promoListImg}>
							<Image src={item.imageUrl} objectFit='cover' layout='fill' />{' '}
						</div>
					</a>
				</Link>
			) : (
				<div className={styles.promoListImg}>
					<Image src={item.imageUrl} objectFit='cover' layout='fill' />{' '}
				</div>
			)}
		</div>
	);
};

export default memo(LandscapeBanner);
